module.exports = __webpack_public_path__ + "static/media/Muhammad-Fathi-Ilham.be861fd7.jpeg";